import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui/button";

const pageOrder = [
  { path: "/", label: "Home" },
  { path: "/announcements", label: "Announcements" },
  { path: "/events", label: "Events" },
  { path: "/staff", label: "Staff Directory" },
  { path: "/resources", label: "Resources" },
  { path: "/contact", label: "Contact" },
  { path: "/gallery", label: "Gallery" },
  { path: "/about", label: "About" },
];

export const PageNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const currentIndex = pageOrder.findIndex(p => p.path === location.pathname);
  const prevPage = currentIndex > 0 ? pageOrder[currentIndex - 1] : null;
  const nextPage = currentIndex < pageOrder.length - 1 ? pageOrder[currentIndex + 1] : null;
  
  if (currentIndex === -1) return null;
  
  return (
    <div className="flex justify-between items-center py-6 px-4 max-w-7xl mx-auto">
      {prevPage ? (
        <Button 
          variant="outline" 
          onClick={() => navigate(prevPage.path)}
          className="flex items-center gap-2 border-[#002147] text-[#002147] hover:bg-[#002147] hover:text-white"
        >
          <ChevronLeft size={20} /> Previous: {prevPage.label}
        </Button>
      ) : <div />}
      {nextPage ? (
        <Button 
          variant="outline" 
          onClick={() => navigate(nextPage.path)}
          className="flex items-center gap-2 border-[#002147] text-[#002147] hover:bg-[#002147] hover:text-white"
        >
          Next: {nextPage.label} <ChevronRight size={20} />
        </Button>
      ) : <div />}
    </div>
  );
};

export default PageNavigation;
